import React, { Fragment } from 'react'
import { string, array, object, func, bool } from 'prop-types'
import { insertValuesInTranslation } from '../../helpers/string-helpers'
import { BRANCH, DETAILS, TYPE_OF_REQUEST, REQUEST_SAMPLE, FORM_WITH_PHONE } from '../../helpers/constants'
import ButtonGroup from '../ui/buttons/button-group'
import { UserInfo, TextArea, ToggleSwitch } from '../ui/form-elements'
const translations = { ...NFT.I18n.single_info_request }

const FormLayout = ({
  countryOptions,
  locationOptions,
  formValues = {},
  errors = {},
  companyName,
  sampleAvailable,
  onFieldChangeHandler,
  isGalleryForm
}) => {
  const branchOptions = translations.branch_options
  const typeOfRequestOptions = Object.values(translations.type_of_request_options)

  // Returns description and placeholder for the message field vary according to the type of request
  const getDetailsSupportMessages = (typeOfRequest = typeOfRequestOptions[0]) => {
    const [key] = Object.entries(translations.type_of_request_options).find(entry => entry[1] === typeOfRequest)
    const descriptionKey = translations.type_of_request_description[key] || translations.message_description
    const placeholderKey = key && key !== 'information' ? translations.message_placeholder : translations.message_placeholder_default
    return {
      detailsDescription: insertValuesInTranslation(descriptionKey, { company: companyName }),
      detailsPlaceholder: insertValuesInTranslation(placeholderKey, { company: companyName, topic: typeOfRequest })
    }
  }
  const { detailsDescription, detailsPlaceholder } = getDetailsSupportMessages(formValues.typeOfRequest)

  return (
    <Fragment>
      <ButtonGroup
        label={translations.type_of_request}
        options={typeOfRequestOptions}
        value={formValues.typeOfRequest}
        fieldName={TYPE_OF_REQUEST}
        errorMessage={errors[TYPE_OF_REQUEST]}
        classesContainer={'js-type-of-request'}
        onValueChange={value => onFieldChangeHandler(TYPE_OF_REQUEST, value)} />
      <UserInfo
        countryOptions={countryOptions}
        locationOptions={locationOptions}
        errors={errors}
        onFieldChangeHandler={onFieldChangeHandler}
        includePhone={FORM_WITH_PHONE.includes(NFT.site)}
        {...formValues} />
      <Fragment>
        <ButtonGroup
          label={translations.branch}
          options={branchOptions}
          value={formValues.branch}
          fieldName={BRANCH}
          errorMessage={errors[BRANCH]}
          onValueChange={value => onFieldChangeHandler(BRANCH, value)} />
      </Fragment>
      <TextArea label={translations.message}
        fieldName={DETAILS}
        description={!isGalleryForm ? detailsDescription : null}
        placeholder={detailsPlaceholder}
        value={formValues.details}
        errorMessage={errors[DETAILS]}
        classes={'js-prefill-message'}
        onValueChange={value => onFieldChangeHandler(DETAILS, value)} />
      {sampleAvailable &&
        <ToggleSwitch name={REQUEST_SAMPLE}
          checked={!!formValues.request_a_sample}
          label={translations.request_a_sample}
          onValueChange={() => onFieldChangeHandler(REQUEST_SAMPLE, +!formValues.request_a_sample)} /> }
    </Fragment>
  )
}

FormLayout.propTypes = {
  countryOptions: array,
  locationOptions: array,
  formValues: object,
  errors: object,
  companyName: string,
  sampleAvailable: bool,
  onFieldChangeHandler: func,
  isGalleryForm: bool,
  prefillMessage: bool
}

export default FormLayout